import React, { useEffect, useState } from "react";
import { Modal, Box, Tabs, Tab, Typography, TextField, Button, MenuItem, Alert,} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { styleModalMenuConfig } from "../../css/modal";
import axiosInstancePromise from "../../general/axiosConfig";

const excluir_col = ['id', 'fecha_ingreso'];

const ModalConfigMenu = ({ open, handleClose }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [campos, setCampos] = useState([]);
  const [ tablaActua, setTablaActual ] = useState('');
  const { control, handleSubmit, reset } = useForm();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [logotipoActual, setLogotipoActual] = useState(null); // imagen almacenada
  const etiquetasCampos = {
    nombre_ofi: "Nombre de la oficina",
    direccion_ofi: "Dirección",
    correo_ofi: "Correo electrónico",
    telefono_ofi: "Teléfono",
    pagina_ofi: "Página web",
    ciudad: "Ciudad",
    // Puedes seguir agregando más si lo necesitas
  };
  const handleClose2 = ()=>{
    localStorage.setItem('view', localStorage.getItem('viewPast'))
    handleClose();
  };
  useEffect(() => {
    if (open) {
      localStorage.setItem('viewPast', localStorage.getItem('view'));
      localStorage.setItem('view', 'general_config');
      setTablaActual('general_config');
    }
  }, [open]);
    
  useEffect(() => {
    const fetchCampos = async () => {
      try {
        const tablaActual = 'general_config';
        const axiosInstance = await axiosInstancePromise;
        const response = await axiosInstance.get(`/campos-tabla/${tablaActual}`);
        const allRows = response.data.rows || [];
        const filtrarCols = allRows.filter(row => !excluir_col.includes(row.COLUMN_NAME));
        setCampos(filtrarCols);

        if (tablaActual === 'general_config') {
          const responseDatos = await axiosInstance.get(`/get-table-general/${tablaActual}`);
          const registros = responseDatos.data.rows || [];
          if (registros.length > 0) {
            const primerRegistro = registros[0];
            const valoresFormateados = {};

            filtrarCols.forEach(col => {
              const nombre = col.COLUMN_NAME;
              valoresFormateados[nombre] = primerRegistro[nombre] || "";
              if (nombre === "logotipo") {
                setLogotipoActual(primerRegistro[nombre]); // guardar imagen previa
              }
            });

            reset(valoresFormateados);
          }

        }
      } catch (error) {
        console.error("Error al cargar los campos de la tabla:", error);
      }
    };

    fetchCampos();
  }, [tablaActua, reset]);

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) {
      setTablaActual('general_config');
    }
    setSelectedTab(newValue);
  };

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      for (const key in data) {
        if (key !== 'logotipo') {
          formData.append(key, data[key]);
        }
      }
      if (data.logotipo instanceof File) {
        formData.append("logotipo", data.logotipo);
      } else {
        if (logotipoActual) {
          formData.append("logotipo", logotipoActual);
        }
      }
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.post(`/guardar-config`,formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      handleClose2(); // Cerrar el modal después de enviar los datos
      alert('La configuración general ha sido guardada con éxito.');
    } catch (error) {
      console.error("Error al enviar los datos:", error.response?.data || error);
    }
  };
  const tabContents = [
    {
      label: "Generalidades",
      content: (
        <Box>
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            {campos.length > 0 ? (
              <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2} mt={2}>
                {campos.map((rows, index) => {
                  if (rows.COLUMN_NAME === "id") {
                    return null; // Excluye el campo id
                  }
                  if (rows.COLUMN_NAME === "logotipo") {
                    return (
                      <Box key={index}>
                        <Controller
                          name={rows.COLUMN_NAME}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <input type="file" accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  field.onChange(file);
                                  if (file) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                      setPreviewUrl(reader.result);
                                    };
                                    reader.readAsDataURL(file);
                                  } else {
                                    setPreviewUrl(null);
                                  }
                                }}
                                style={{ marginTop: "16px", display: "block", width: "100%" }}
                              />
                              {previewUrl && (
                                <Box mt={1}>
                                  <img src={`/public/${previewUrl}`} alt="Vista previa" style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }} />
                                </Box>
                              )}
                              {!previewUrl && logotipoActual && (
                                <Box mt={1}>
                                  <img
                                    src={`/public/${logotipoActual}`}
                                    alt="Logotipo actual"
                                    style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                                  />
                                </Box>
                              )}
                            </>
                          )}
                        />
                        <Typography variant="caption" color="textSecondary">
                          Solo se permiten archivos de imagen.
                        </Typography>
                      </Box>
                    );
                  }
                  return (
                    <Box key={index}>
                      <Controller
                        name={rows.COLUMN_NAME} 
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <TextField
                            {...field}
                            margin="normal"
                            required
                            fullWidth
                            type={rows.DATA_TYPE === "int" ? "number" : "text"}
                            label={etiquetasCampos[rows.COLUMN_NAME] || rows.COLUMN_NAME}
                          />
                        )}
                      />
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <Typography variant="body1" mt={2}>
                Cargando campos...
              </Typography>
            )}
            <Box mt={2} display="flex" justifyContent="center">
              <Button type="submit" variant="contained" sx={{ background: "black" }}>
                Guardar
              </Button>
            </Box>
          </form>
        </Box>
      ),
    },
    // {
    //   label: "Notificaciones",
    //   content: (
    //     <Box>
    //       <TextField
    //         label="Correo de Notificaciones"
    //         fullWidth
    //         margin="normal"
    //         variant="outlined"
    //       />
    //       <TextField
    //         label="Teléfono para Alertas"
    //         fullWidth
    //         margin="normal"
    //         variant="outlined"
    //       />
    //       <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
    //         <Button variant="contained" color="primary" sx={{ mt: 2 }}>
    //           Guardar Preferencias
    //         </Button>
    //       </Box>
    //     </Box>
    //   ),
    // },
  ];

  return (
    <Modal open={open} onClose={handleClose2} aria-labelledby="modal-config-menu-title" aria-describedby="modal-config-menu-description">
      <Box sx={styleModalMenuConfig} >
        <Box mb={1} display="flex" justifyContent="center">
          <Typography id="modal-config-menu-title" variant="h6" sx={{ mb: 1 }}>
            Menú de Configuración
          </Typography>
        </Box>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          sx={{ mb: 2 }}
        >
          {tabContents.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
        <Box>{tabContents[selectedTab].content}</Box>
      </Box>
    </Modal>
  );
};

export default ModalConfigMenu;
